import { RouteID, RoutesService } from 'app/model/services/routes.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleHandler } from 'app/types/handlers';
import { RouteInfo, RouteService } from 'app/model/services/route.service';
import { TypedHandler } from './../../../../types/handlers';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

export type RouteConfigOKHandlerParams = { route: RouteInfo, includeVertex: boolean }
export type RouteConfigParams = {
  okHandler: TypedHandler<RouteConfigOKHandlerParams>;
  cancelHandler: SimpleHandler;
  route?: RouteInfo;
  addTo?: RouteID;
  promptAddVertex?: boolean;
  promptAddSegVertex?: boolean;

}

@Component({
  selector: 'app-route-config-entry',
  templateUrl: './route-config-entry.component.html',
  styleUrls: ['./route-config-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouteConfigEntryComponent implements OnInit {
  private _params?: RouteConfigParams;
  private _ready: boolean = false;
  public hasParent = false;
  public parentRoute = '';
  public showVertexPrompt: boolean = false;
  public showSegVertexPrompt:boolean  = false;
  private parent?: RouteID;

  @ViewChild('routeForm') routeForm!: NgForm;
  constructor(public modal: NgbActiveModal, private cdr: ChangeDetectorRef, private routes: RoutesService, private routeSvc: RouteService) {

  }

  public includeVertex = false;
  public includeSegVertex = false;

  public get name() {
    return (!!this._params?.route?.name) ? this._params.route.name : '';
  }
  public get isNewRoute(): boolean {
    return (this._params?.route !== undefined);
  }
  ngOnInit(): void {
    this._ready = false;
  }
  Show(params?: RouteConfigParams) {
    this._params = params;
    if (this._params === undefined) return this.Refresh();
    if (!!this._params?.addTo) {
      this.parent = this._params.addTo;
    } else if (this._params?.route?.parent) {
      this.parent = this._params.route.parent;
    }
    if (!!this._params?.promptAddVertex) {
      this.showVertexPrompt =  true;
    }
    if(!!this._params?.promptAddSegVertex) {
      this.showSegVertexPrompt = true;

    }
    if (!!this.parent) {
      this.parentRoute = this.routeSvc.GetFullName(this.parent, '', '/');
      this.hasParent = true;
    }

    this.Refresh();
  }
  Hide() {
    this._params = undefined;
    this.Refresh();
    this.modal.close();
  }
  Refresh() {
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }

  Submit() {
    if (!this._params) return;
    let route: any;
    if (!this.isNewRoute && this._params.route) {
      route = this._params.route;
      route.name = this.routeForm.value.name
      this._params.okHandler(route);
      this._params = undefined;
      this.Refresh();
      this.Hide();

    } else {
      route = { name: this.routeForm.value.name, data: {} };
      route.data = {};
      this.routes.AddRoute(route as RouteInfo, this._params?.addTo);
      RoutesService.Notify('route-added', route.id, undefined, () => {
        if (!this._params) return;
        let vInclude = false;
        if(this.showVertexPrompt) {
          vInclude = this.includeVertex;
        }
        let vsInclude = false;
        if(this.showSegVertexPrompt) {
          vsInclude = this.includeSegVertex;
        }
        this._params.okHandler({ route: (route), includeVertex: (vInclude || vsInclude)});
        this._params = undefined;
        this.Refresh();
        this.Hide();

      });

    }
  }
}
